import React, { useState, useEffect, Fragment } from 'react';

import { useSelector } from 'react-redux';
import { Button, Text } from '@BICE_Vida/components';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { Container, Col } from '../../../designSystem';
import Section from '../../Section';
import Carousel from '../BenefitsCarousel';

import styles from './BenefitsFeatures.module.scss';
import { AvailablePlans as AvailablePlansType } from '../../../types/availablePlans';
import componentsId from '../../../utils/componentsId';
import { benefitsPageTexts } from '../../../utils/generalTexts';
import { breakPointLg } from '../../../utils/constants';
import routes from '@/utils/routes';
import { splitInChunks } from '@/utils/format';
import PreexistingConditionsModal from '@/components/PreexistingConditionsHeader/PreexistingConditionsModal';
import * as plansSelectors from '@/redux/plans/selectors';

const BenefitsFeatures = () => {
  const router = useRouter();
  const [showDesktop, setShowDesktop] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const featuresCardsDesktop = splitInChunks(benefitsPageTexts.featuresCards, 2);
  const availablePlans: AvailablePlansType = useSelector(plansSelectors.getAvailablePlans);

  useEffect(() => {
    const onResize = () => {
      setShowDesktop(window.innerWidth > breakPointLg);
    };

    window.addEventListener('resize', onResize);
    onResize();

    window.scrollTo(0, 0);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  const btnEstimateClick = () => {
    router.push(routes.wizardPlan);
  };

  return (
    <Section id={componentsId.benefits.features.section} customClass={styles.benefits_features}>
      <PreexistingConditionsModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        availablePlans={availablePlans.length}
      />
      <Container className={styles.benefits_features_container}>
        <Col sm={2} md={4} lg={4} xl={5} className={styles.benefits_feature_title_container}>
          <Text fontTypo="title-large" tag="h1" className={styles.benefits_feature_title}>
            {benefitsPageTexts.featuresTitle}
          </Text>
          {showDesktop && (
            <Button
              className={styles.benefits_features_btn_container}
              variant="primary"
              text="Cotizar ahora"
              size="large"
              iconPosition="right"
              icon="arrow_forward"
              onClick={btnEstimateClick}
            />
          )}
        </Col>
        <Col sm={4} md={8} lg={8} xl={8} className={styles.benefits_features_card_container}>
          <Fragment>
            {showDesktop ? (
              <Carousel showButtons id={componentsId.benefits.features.carousel} bulletSlide>
                {featuresCardsDesktop.map((cards, idx: number) => (
                  <div
                    key={`benefits_features_cards_${idx}`}
                    className={styles.benefits_features_cards_multiple}
                  >
                    {cards.map((card, idx) => (
                      <div
                        key={`benefits_features_card_${idx}`}
                        className={styles.benefits_features_card}
                      >
                        <div className={styles.features_card_icon}>
                          <Image src={card.icon} alt="" width={80} height={80} />
                        </div>
                        <div className={styles.features_card_texts}>
                          <Text className={styles.features_card_title}>{card.title}</Text>
                          <Text className={styles.features_card_paragraph}>
                            {card.paragraph()}
                            {card.modalText && (
                              <span
                                onClick={() => setIsOpen(true)}
                                className={styles.link_excepcions}
                              >
                                aqui
                              </span>
                            )}
                          </Text>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </Carousel>
            ) : (
              <div className={styles.benefits_features_cards_mobile}>
                <div>
                  <Carousel gap={16} id={componentsId.benefits.features.carousel} bulletSlide>
                    {benefitsPageTexts.featuresCards
                      .filter((card) => card.showOnMobile)
                      .map((card, idx) => (
                        <div
                          key={`benefits_features_card_${idx}`}
                          className={styles.benefits_features_card}
                        >
                          <div className={styles.features_card_icon}>
                            <Image src={card.icon} alt="" width={80} height={80} />
                          </div>
                          <div className={styles.features_card_texts}>
                            <Text className={styles.features_card_title}>{card.title}</Text>
                            <Text className={styles.features_card_paragraph}>
                              {card.paragraph()}
                              {card.modalText && (
                                <button
                                  onClick={() => setIsOpen(true)}
                                  className={styles.link_excepcions}
                                >
                                  aqui
                                </button>
                              )}{' '}
                            </Text>
                          </div>
                        </div>
                      ))}
                  </Carousel>
                </div>
              </div>
            )}
          </Fragment>
        </Col>
        {!showDesktop && (
          <Col className={styles.benefits_features_btn_container}>
            <Button
              className={styles.benefits_features_btn}
              variant="primary"
              text="Cotizar ahora"
              onClick={btnEstimateClick}
            />
          </Col>
        )}
      </Container>
    </Section>
  );
};

export default BenefitsFeatures;
